import { useMutation, useQuery } from '@tanstack/react-query'
import { apiFetch } from './client'

export interface ScenarioInfo {
  name: string
  description: string
}

export interface SimulateResponse {
  success: boolean
  call_sid: string
  scenario: string
}

export function useListScenarios() {
  return useQuery({
    queryKey: ['copilot-dev-scenarios'],
    queryFn: () => apiFetch<ScenarioInfo[]>('/copilot/dev/scenarios'),
    // Treat as a feature-flag probe: don't retry on failure (the route may not
    // exist when COPILOT_SANDBOX_ENABLED is false) and cache indefinitely so the
    // sidebar doesn't keep hammering a missing endpoint.
    retry: false,
    staleTime: Infinity,
  })
}

export function useStartSimulatedCopilotCall() {
  return useMutation({
    mutationFn: (scenarioName: string) =>
      apiFetch<SimulateResponse>('/copilot/dev/simulate', {
        method: 'POST',
        body: JSON.stringify({ scenario: scenarioName }),
      }),
  })
}
